// TODO: use IndexedDB?

const memoryStore = {} as { [key: string]: any };

export class Store {
  public static appName: string;
  public static set(key: string, value: any) {
    if (this.appName) {
      key = `${Store.appName}:${key}`;
    }
    if (window.localStorage) {
      if (value === null || value === undefined) {
        window.localStorage.removeItem(key);
      }

      window.localStorage.setItem(key, JSON.stringify(value));
    } else {
      memoryStore[key] = JSON.stringify(value);
    }
  }

  public static get<T>(key: string): T | null {
    if (this.appName) {
      key = `${Store.appName}:${key}`;
    }
    try {
      if (window.localStorage) {
        const json = window.localStorage.getItem(key);
        return json ? JSON.parse(json) : null;
      } else {
        return memoryStore[key] ? JSON.parse(memoryStore[key]) : null;
      }
    } catch {
      return null;
    }
  }
}
